export enum ProductCategoryEnum {
  OWNER_OCCUPIED = 'OWNER_OCCUPIED',
  BUY_TO_LET = 'BUY_TO_LET',
}
